<template>
    <div>
        <h5 class="tw-font-semibold tw-text-3xl tw-pb-2" v-if="isFullList">{{word.all_matches}}</h5>

        <div class="filter-matches w-100 tw-mb-6">
            <div class="col-md-6 mb-3">
                <span class="d-inline-block filter-matches-who mb-2">{{word.i_am}}:</span>
                <div class="d-inline-block ml-2 gender">
                    <label>
                        <input
                            type="radio"
                            value="man"
                            v-model="filters.genders.iAm"
                        />
                        <div class="male box">
                            <span class="sex-type">
                                <i class="fas fa-male"></i>
                                {{word.man}}
                            </span>
                        </div>
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="woman"
                            v-model="filters.genders.iAm"
                        />
                        <div class="female box mt-2">
                            <span class="sex-type">
                                <i class="fas fa-female"></i>
                                {{word.woman}}
                            </span>
                        </div>
                    </label>

                </div>
            </div>
            <div class="col-md-6 mb-3">
                <span class="d-inline-block filter-matches-ages mb-2">{{word.looking_for}}:</span>
                <div class="d-inline-block  ml-2 gender">
                    <label>
                        <input
                            type="radio"
                            value="man"
                            v-model="filters.genders.lookingFor"
                        />
                        <div class="male box">
                            <span class="sex-type">
                                <i class="fas fa-male"></i>
                                {{word.man}}
                            </span>
                        </div>
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="woman"
                            v-model="filters.genders.lookingFor"
                        />
                        <div class="female box mt-2">
                            <span class="sex-type">
                                <i class="fas fa-female"></i>
                                {{word.woman}}
                            </span>
                        </div>
                    </label>

                </div>
            </div>
            <div class="col-md-3 filter-matches-box pl-1">
                <div class="select-change">
                    <span class="filter-matches-ages ml-2">{{word.ages}}:</span>
                    <select v-model="filters.startAge">
                        <option v-for="age in ages">{{ age }}</option>
                    </select>
                    <span class="filter-matches-line"></span>
                    <select v-model="filters.endAge">
                        <option v-for="age in ages">{{ age }}</option>
                    </select>
                </div>
            </div>
            <div class="offset-3"></div>
            <div class="col-md-1 mt-1 mr-2">
                <span class="filter-matches-ages d-inline-block">{{word.countries}}:</span>
            </div>
            <div class="col-md-4 mr-2 p-1">
               <v-select-favorite-countries v-model="filters.favoriteCountries" />
            </div>
            <div class="tab-control">
                <button class="extra-filters tw-bg-transparent tw-border-none">
                    <i class="fas fa-user-plus mr-1 ml-1"></i> {{text.add_more_options}}
                    <div class="tab-control-box tw-rounded tw-shadow-lg tw-border tw-border-solid tw-border-gray-300">
                        <div class="all-chtab">
                            <div
                                v-for="(criteria, key) in filters.criteria"
                                class="chTab"
                                :class="{ 'tab-header-active': activeOptionTab === key }"
                                :data-t="key"
                                @click="activeOptionTab = key"
                                v-html="changeKeyToNormalString(key)"
                            />
                        </div>

                        <div class="tab--content">
                            <div
                                v-for="(criteria, key) in filters.criteria"
                                class="tab-content-ch"
                                :class="['tab-content-' + key,{'tab-content-body':activeOptionTab !== key}]"
                            >
                                <!--{{criteria}}-->
                                <div class="options-label">
                                    <template v-if="key === 'haveKids'">
                                        <div>
                                            <label
                                                for="haveKids-yes"
                                                :class="{
                                                        'option-selected':
                                                            filters.criteria
                                                                .haveKids === true
                                                    }"
                                            >{{word.yes}}</label
                                            >
                                            <input
                                                type="radio"
                                                id="haveKids-yes"
                                                :value="true"
                                                v-model="
                                                        filters.criteria.haveKids
                                                    "
                                            />
                                        </div>
                                        <div>
                                            <label
                                                for="haveKids-no"
                                                :class="{
                                                        'option-selected':
                                                            filters.criteria
                                                                .haveKids === false
                                                    }"
                                            >{{word.no}}</label
                                            >
                                            <input
                                                type="radio"
                                                id="haveKids-no"
                                                :value="false"
                                                v-model="
                                                        filters.criteria.haveKids
                                                    "
                                            />
                                        </div>
                                        <div>
                                            <label
                                                for="haveKids-all"
                                                :class="{
                                                        'option-selected':
                                                            filters.criteria
                                                                .haveKids === null
                                                    }"
                                            >{{word.all}}</label
                                            >
                                            <input
                                                type="radio"
                                                id="haveKids-all"
                                                :value="null"
                                                v-model="
                                                        filters.criteria.haveKids
                                                    "
                                            />
                                        </div>
                                    </template>
                                    <template
                                        v-else-if="
                                                key === 'weight' || key === 'height'
                                            "
                                    >
                                        <div class="range-input">
                                            {{word.from}}:
                                            <input
                                                type="number"
                                                v-model="
                                                        filters.criteria[key].from
                                                    "
                                            />
                                        </div>
                                        <div class="range-input">
                                            {{word.to}}:
                                            <input
                                                type="number"
                                                v-model="
                                                        filters.criteria[key].to
                                                    "
                                            />
                                        </div>
                                    </template>
                                    <template v-else-if="key === 'interest'">
                                        <div
                                            v-for="(record,
                                                index) in extractRecords(key)"
                                        >
                                            <label
                                                :for="key + '-' + index"
                                                :class="{
                                                        'option-selected': filters.criteria[
                                                            key
                                                        ].find(
                                                            item =>
                                                                item == record.id
                                                        )
                                                    }"
                                                v-html="JSON.parse(record.title)['en']"
                                            />
                                            <input
                                                type="checkbox"
                                                :id="key + '-' + index"
                                                :value="record.id"
                                                v-model="filters.criteria[key]"
                                            />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-for="(record,index) in extractRecords(key)">
                                            <label :for="key + '-' + index"
                                                :class="{ 'option-selected': filters.criteria[ key ].find( item => item == record.id ) }"
                                                v-html="record.title"
                                            />
                                            <input
                                                type="checkbox"
                                                :id="key + '-' + index"
                                                :value="record.id"
                                                v-model="filters.criteria[key]"
                                            />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </button>
                <div class="buttons-section">
                    <button
                        class="reset-control-button"
                        @click="reset()"
                        v-if="hasOldCriteria"
                    >
                        {{text.reset_extra_filters}}
                    </button>
                    <button class="tab-control-btn" @click="search()" :disabled="isLoading">
                        {{word.find}}
                    </button>
                </div>
            </div>
        </div>

        <div class="tw-relative">
            <div v-if="isLoading" class="tw-flex tw-justify-center">
                <div class="tw-px-10 tw-py-4 tw-font-bold tw-bg-white">
                    <div class="tw-h-20">
                        <loading color="green" :active="true === true" spinner="bar-fade-scale"/>
                    </div>
                    {{word.please_wait}}
                </div>
            </div>
            <div v-else>
                <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-6 tw-rounded-lg">
                    <div v-for="user in people">
                        <a :href="'/user/' + user.user_name" style="display: block;">
                            <div
                                :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
                                class="grid-avatar-dashboard grid-avatar-dashboard tw-rounded tw-shadow-md tw-border tw-border-solid tw-border-gray-300"
                            >
                                <div class="match-cart-dashboard">
                                    <h5 v-if="user.age">{{ user.name }}, {{user.age}}</h5>
                                    <h5 v-else>{{ user.name }}</h5>
                                    <div v-if="user.place" class="mb-2">
                                        <i class="fas fa-map-marker-alt"> </i> {{user.place}}
                                    </div>
                                    <create-chat :user="user"></create-chat>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>

                <div v-if="people.length === 0">{{text.did_not_match_any_user}}</div>

                <div class="tw-mt-6 tw-flex tw-justify-center" v-if="!isFullList && people.length >= 8">
                    <a href="/dashboard/matches" class="btn text-center dash-all-Matches">{{word.all_matches}}</a>
                </div>

                <infinite-loading v-if="isFullList" @infinite="infiniteHandler" spinner="waveDots" class="loader">
                    <div slot="no-more" class="tw-mt-6 tw-text-2xl tw-text-center">{{word.no_more}}</div>
                    <div slot="no-results" class="tw-mt-6 tw-text-2xl tw-text-center">{{word.no_more}}</div>
                </infinite-loading>
            </div>
        </div>

    </div>
</template>

<script>
    import InfiniteLoading from "vue-infinite-loading";
    import Multiselect from "vue-multiselect";
    import CreateChat from "../chats/CreateChat";

    export default {
        name: "MatchesList",

        components: {
            InfiniteLoading,
            CreateChat,
            Multiselect
        },

        props: ["isFullList"],

        data() {
            return {
                isLoading: true,
                defaultCriteria: null,
                word: window.word,
                text: window.text,
                filters: {
                    genders: {
                        iAm: "man",
                        lookingFor: "woman"
                    },
                    startAge: 18,
                    endAge: 18,
                    favoriteCountries: [],
                    criteria: {
                        hairColor: [],
                        eyeColor: [],
                        bodyType: [],
                        drink: [],
                        smoke: [],
                        relationStatus: [],
                        educationLevel: [],
                        language: [],
                        interest: [],
                        haveKids: null,
                        height: {
                            from: null,
                            to: null
                        },
                        weight: {
                            from: null,
                            to: null
                        }
                    }
                },
                ages: [18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70],
                options: [],
                activeOptionTab: null,
                people: [],
                page: 1
            };
        },

        methods: {
              changeKeyToNormalString(text) {
                return text.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
                    return str.toUpperCase();
                });
            },
            search() {
                this.isLoading = true;

                axios
                    .post("/en/search-people", {
                        ...this.filters,
                        ...{page: this.page}
                    })
                    .then(response => {
                        this.people = response.data.data;
                        this.isLoading = false;
                    })
                    .catch(() => this.isLoading = false)
            },
            extractRecords(key) {
                let option = this.options.find(element => element.key === key);

                return option === undefined ? [] : option.records;
            },
            infiniteHandler($state) {
                axios
                    .post("/en/search-people", {
                        ...this.filters,
                        ...{page: this.page + 1}
                    })
                    .then(response => {
                        if (response.data.data.length) {
                            this.page = response.data.meta.current_page + 1;
                            this.people.push(...response.data.data);
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    });
            },
            reset() {
                this.filters.criteria = {...this.defaultCriteria};
                this.search();
            }
        },

        computed: {
            hasOldCriteria() {
                return !_.isEqual(this.filters.criteria, this.defaultCriteria);
            }
        },

        async mounted() {
            await axios.get("/search-options").then(response => {
                this.options = response.data.data;
            });

            await axios.get("/search-filters").then(response => {
                this.defaultCriteria = {...this.filters.criteria};
                this.filters = {...this.filters, ...response.data.data};

                this.filters.favoriteCountries.forEach((item, key) => {
                    this.$emit('handle-select', item.id);
                })
            });

            await this.search();
        }
    };
</script>

<style>
    .range-input {
        display: inline-block !important;
        padding-right: 20px;
    }

    .range-input input {
        display: inline-block !important;
        border-radius: 4px;
        border: 1px solid #e0e0e0;
        margin-left: 4px;
        width: 50px;
    }

    .loader {
        width: 100%;
    }

    .option-selected {
        background-color: #3a8bd1 !important;
        color: #ffffff;
    }

    .loading-wrapper {
        position: absolute;
        left: 0;
        margin-top: -25px;
        width: 100%;
        height: 100%;
        z-index: 100;
        padding: 0 15px;
    }

    .loading-overlay {
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        border-radius: 10px;
        padding: 50px 0;
    }

    .loading-box {
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0 0 5px 0 #dfdfdf;
        margin: 0 auto;
        width: 300px;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .match-grid-dash {
        position: relative;
    }

    .gender input[type="radio"] {
        display: none;
    }

    .gender input[type="radio"]:checked + .box span {
        transform: translateY(50px);
    }

    .gender .sex-type {
        align-items: center;
        flex-direction: row;
    }

    .gender .sex-type i {
        margin-right: 5px;
    }

    .gender label {
        margin-bottom: 0;
    }

    .gender .box {
        padding: 1px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .gender .box span {
        transform: translate(0, 50px);
        color: #FF1494;
        font-size: 14px;
    }

    .gender input[type="radio"]:checked + .male {
        border: 1px solid #d40c79;
        background-color: #FF1494;
    }

    .gender input[type="radio"]:checked + .male span {
        color: #fff;
    }

    .gender input[type="radio"]:checked + .female {
        border: 1px solid #d40c79;
        background-color: #FF1494;
    }

    .gender input[type="radio"]:checked + .female span {
        color: #fff;
    }

    .gender .box {
        width: 110px;
        height: 30px;
        background-color: transparent;
        border-radius: 4px;
        border: 1px solid #FF1494;
    }

    .gender .male {
        background-color: transparent;
    }

    .filter-matches .multiselect__single {
        display: none !important;
    }
</style>
